import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Badge,
} from 'reactstrap'
import moment from 'moment'
import qs from 'qs'
import oikosApi from '../../../../services/oikos'
import { getLegalSolicitationResponses } from '../../../../store/ducks/management'
import { getOikosFileUrl } from '../../../../utils/linksOikos/link'

const fileLabel = (caminho, desc) => (
  desc || (caminho ? String(caminho).split('/').pop() : 'Anexo')
)

/** Une coluna `anexo` + registros da tabela `arquivo`, sem duplicar caminho. */
const collectAnexoItems = (anexoColumn, arquivoRows = []) => {
  const items = []
  const seen = new Set()
  const push = (path, label) => {
    if (!path) return
    const key = String(path)
    if (seen.has(key)) return
    seen.add(key)
    items.push({ path: key, label: fileLabel(key, label) })
  }
  push(anexoColumn)
  ;(Array.isArray(arquivoRows) ? arquivoRows : []).forEach((row) => {
    if (row && row.arquivo_caminho) {
      push(row.arquivo_caminho, row.arquivo_desc)
    }
  })
  return items
}

const openAnexo = (e, caminho) => {
  if (e && e.preventDefault) e.preventDefault()
  if (e && e.stopPropagation) e.stopPropagation()
  const url = getOikosFileUrl(caminho)
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}

class ProjLegalDetailsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      solicitationArquivos: [],
      responseArquivosById: {},
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      if (this.props.solicitation) {
        const sid = this.props.solicitation.id || this.props.solicitation.solicitacoes_juridicas_id
        this.props.getLegalSolicitationResponses(sid)
        this.loadSolicitationArquivos(sid)
        this.setState({ responseArquivosById: {} })
      }
    }

    if (!this.props.isOpen && prevProps.isOpen) {
      this.setState({ solicitationArquivos: [], responseArquivosById: {} })
    }

    const prev = prevProps.legalSolicitationResponses
    const curr = this.props.legalSolicitationResponses
    if (this.props.isOpen && curr && curr !== prev) {
      this.loadResponseArquivos(curr)
    }
  }

  fetchArquivos = async (tabRef, tabId) => {
    if (!tabRef || tabId == null || tabId === '') return []
    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'arquivo',
        data: {
          arquivo_tabRef: tabRef,
          arquivo_tabId: tabId,
        },
      })}`)
      return Array.isArray(res.data)
        ? res.data.filter(a => a && a.arquivo_caminho)
        : []
    } catch (e) {
      console.log('Erro ao buscar arquivos:', e)
      return []
    }
  }

  loadSolicitationArquivos = async (solicitacaoId) => {
    const list = await this.fetchArquivos('solicitacoes_juridicas', solicitacaoId)
    if (this.props.isOpen) {
      this.setState({ solicitationArquivos: list })
    }
  }

  loadResponseArquivos = async (responses) => {
    const byId = {}
    await Promise.all((Array.isArray(responses) ? responses : []).map(async (res) => {
      const id = res.id || res.solicitacoes_juridicas_respostas_id
      if (!id) return
      byId[id] = await this.fetchArquivos('solicitacoes_juridicas_respostas', id)
    }))
    if (this.props.isOpen) {
      this.setState({ responseArquivosById: byId })
    }
  }

  renderAnexoLinks = (items, emptyLabel = null) => {
    if (!items || items.length === 0) {
      return emptyLabel
        ? <span className="text-muted" style={{ fontSize: 13 }}>{emptyLabel}</span>
        : null
    }
    return (
      <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {items.map(({ path, label }) => (
          <Button
            key={path}
            color="primary"
            size="sm"
            outline
            title={path}
            onClick={e => openAnexo(e, path)}
          >
            <i className="ri-attachment-line" /> {label}
          </Button>
        ))}
      </div>
    )
  }

  render() {
    const {
      isOpen, toggle, solicitation, pfList,
      formatProjSolicitationStatus, getProjContractLabel,
      getLegalSolicitationResponsesIsLoading,
      legalSolicitationResponses,
    } = this.props
    const { solicitationArquivos, responseArquivosById } = this.state

    const originalAnexoItems = solicitation
      ? collectAnexoItems(solicitation.anexo, solicitationArquivos)
      : []

    const responsesSorted = [...(legalSolicitationResponses || [])]
      .sort((a, b) => {
        const da = a.data_criacao ? moment(a.data_criacao).valueOf() : 0
        const db = b.data_criacao ? moment(b.data_criacao).valueOf() : 0
        return da - db
      })

    const latestStatus = [...responsesSorted].reverse().find(r => r.status_alterado_para)?.status_alterado_para
      || solicitation?.status

    return (
      <Modal centered isOpen={isOpen} toggle={toggle} size="lg" enforceFocus={false}>
        <ModalHeader toggle={toggle}>
          Detalhes do Chamado: {solicitation?.tipo_assunto || '—'}
        </ModalHeader>
        <ModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          {solicitation && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Solicitante</span>
                  <strong style={{ fontSize: '14px', color: '#495057' }}>{solicitation.solicitante || '—'}</strong>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Data</span>
                  <strong style={{ fontSize: '14px', color: '#495057' }}>
                    {solicitation.data_criacao ? moment(solicitation.data_criacao).format('DD/MM/YYYY') : '—'}
                  </strong>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Prazo</span>
                  <strong style={{ fontSize: '14px', color: '#495057' }}>
                    {solicitation.prazo_atendimento ? moment(solicitation.prazo_atendimento).format('DD/MM/YYYY') : '—'}
                  </strong>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Status</span>
                  {formatProjSolicitationStatus({ ...solicitation, status: latestStatus })}
                </div>
              </div>

              {solicitation.contrato_id && (
                <div style={{ marginBottom: '10px', fontSize: '13px' }}>
                  <strong>Contrato:</strong> {getProjContractLabel()}
                </div>
              )}
              {solicitation.fato_gerador && (
                <div style={{ marginBottom: '10px', fontSize: '13px' }}>
                  <strong>Fato gerador:</strong> {solicitation.fato_gerador}
                </div>
              )}
              <div style={{ padding: '10px', backgroundColor: '#f1f5f7', borderRadius: '4px', fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: solicitation.teor }} />
              <div style={{ marginTop: '12px' }}>
                <strong style={{ fontSize: 13 }}>Anexo original da solicitação</strong>
                {this.renderAnexoLinks(
                  originalAnexoItems,
                  'Nenhum anexo na solicitação.'
                )}
              </div>
            </div>
          )}

          <h5 className="mt-4 mb-3" style={{ fontSize: '15px', fontWeight: 'bold', color: '#495057' }}>Histórico de Respostas</h5>

          {getLegalSolicitationResponsesIsLoading ? (
            <div className="text-center my-4"><div className="spinner-border text-primary" role="status" /></div>
          ) : (
            <div>
              {responsesSorted.length > 0 ? (
                responsesSorted.map((res) => {
                  const responseId = res.id || res.solicitacoes_juridicas_respostas_id
                  const responseAnexoItems = collectAnexoItems(
                    res.anexo,
                    responseArquivosById[responseId]
                  )
                  return (
                    <div key={responseId} style={{ padding: '12px', backgroundColor: '#fff', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px' }}>
                        <strong>
                          {res.autor_id
                            ? (pfList?.find(p => String(p.pf_id) === String(res.autor_id))?.pf_nome || `Autor ID: ${res.autor_id}`)
                            : (res.autor_pf_id ? `Autor ID: ${res.autor_pf_id}` : 'Jurídico/Sistema')}
                        </strong>
                        <span className="text-muted">{moment(res.data_criacao).format('DD/MM/YYYY HH:mm')}</span>
                      </div>
                      <div style={{ fontSize: '14px', color: '#333' }} dangerouslySetInnerHTML={{ __html: res.teor }} />

                      <div style={{ marginTop: '8px' }}>
                        {res.status_alterado_para && (
                          <Badge color="light" style={{ border: '1px solid #ddd', color: '#555', marginBottom: 6 }}>
                            Status alterado para: {res.status_alterado_para}
                          </Badge>
                        )}
                        <div>
                          <strong style={{ fontSize: 12, color: '#666' }}>Anexos desta resposta</strong>
                          {this.renderAnexoLinks(
                            responseAnexoItems,
                            'Sem anexo nesta resposta.'
                          )}
                        </div>
                      </div>
                    </div>
                  )
                })
              ) : (
                <p className="text-muted" style={{ fontSize: '13px' }}>Nenhuma resposta registrada ainda.</p>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            onClick={toggle}
            color="light"
            className="waves-effect"
          >
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  getLegalSolicitationResponsesIsLoading: state.management.getLegalSolicitationResponsesIsLoading,
  legalSolicitationResponses: state.management.legalSolicitationResponses,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getLegalSolicitationResponses,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProjLegalDetailsModal)
